var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.952,
    height: 14.812,
    viewBox: "0 0 15.952 14.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1948",
    "data-name": "Rectangle 1948",
    width: 15.952,
    height: 14.812,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21866",
    "data-name": "Group 21866",
    transform: "translate(17 -6.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21865",
    "data-name": "Group 21865",
    transform: "translate(-17 6.647)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11199",
    "data-name": "Path 11199",
    d: "M14.821,2.97h-3v-1.1A1.87,1.87,0,0,0,9.952,0H5.968A1.87,1.87,0,0,0,4.1,1.868v1.1H1.131A1.133,1.133,0,0,0,0,4.1V7.493a.3.3,0,0,0,.226.29l.338.085v5.815a1.13,1.13,0,0,0,1.128,1.128H14.26a1.13,1.13,0,0,0,1.128-1.128V7.868l.338-.085a.3.3,0,0,0,.226-.29V4.1A1.133,1.133,0,0,0,14.821,2.97ZM4.7,1.868A1.272,1.272,0,0,1,5.968.6H9.952a1.272,1.272,0,0,1,1.271,1.271v1.1h-.6v-1.1a.675.675,0,0,0-.674-.674H5.968a.675.675,0,0,0-.674.674v1.1H4.7Zm1.194,1.1v-1.1a.078.078,0,0,1,.077-.077H9.952a.078.078,0,0,1,.077.077v1.1ZM.6,4.1a.535.535,0,0,1,.534-.534h13.69a.535.535,0,0,1,.534.534V7.26l-.33.084h-.009L11.6,8.211l-2.583.654v-.2a.72.72,0,0,0-.718-.72H7.623a.72.72,0,0,0-.718.72v.191L.935,7.345h0L.6,7.261ZM7.5,9.246V8.665a.122.122,0,0,1,.121-.123H8.3a.121.121,0,0,1,.121.12v1.487a.122.122,0,0,1-.121.121H7.622a.121.121,0,0,1-.121-.121Zm6.759,4.968H1.692a.532.532,0,0,1-.531-.531V8.019L6.9,9.472v.677a.719.719,0,0,0,.718.718H8.3a.719.719,0,0,0,.718-.718V9.482l4.039-1.024,1.737-.44v5.664A.532.532,0,0,1,14.26,14.214Z",
    transform: "translate(0)",
    fill: "#040227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/briefcase-icon.4b2630c126d9adbb67046534647d2f98.svg";
export { ForwardRef as ReactComponent };